import { Icon } from '@livable/saas-react-components';
import { Step, StepLabel, Stepper } from '@mui/material';
import React from 'react';
import useEnrollResidentStepperStyles from './styles';
const EnrollResidentStepper = _ref => {
  let activeStep = _ref.activeStep,
    completedSteps = _ref.completedSteps,
    handleStep = _ref.handleStep,
    steps = _ref.steps;
  const classes = useEnrollResidentStepperStyles();
  const isActive = index => index <= completedSteps || index === activeStep;
  const getStepIcon = index => () => /*#__PURE__*/React.createElement(Icon, {
    type: index === activeStep || index >= completedSteps ? 'edit' : 'success'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.stepperWrapper
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true
  }, steps.map((step, index) => /*#__PURE__*/React.createElement(Step, {
    key: step.label,
    className: isActive(index) ? classes.activeStep : classes.disabledStep
  }, /*#__PURE__*/React.createElement(StepLabel, {
    onClick: handleStep(index),
    StepIconComponent: getStepIcon(index)
  }, step.label)))));
};
export default EnrollResidentStepper;